export default __webpack_public_path__ + "static/media/tutorial_preview_search1.3f6985cb.png";